<script>
import clientMixins from 'utils/client-mixins';
import { privileges } from 'domains/base/_base-enum';

export default {
  mixins: [clientMixins],
  data: () => ({
    privileged: false,
  }),
  created() {
    if (this.hasPrivilege(privileges.STORES)) {
      this.privileged = true;
    } else {
      this.$router.replace('/');
    }
  },
};
</script>

<template lang='pug'>
router-view(v-if='privileged')
</template>

<style>
@import '~import/index';
@import '~styles/index';

.stores {
  @extend %content-margin;
}
</style>